// Lurox Menu - 3 Level Navigation
const luroxBtn = document.querySelector('.lurox-hamburger');
const luroxDrawer = document.querySelector('.lurox-drawer');
const luroxOverlay = document.querySelector('.lurox-overlay');
const luroxClose = document.querySelector('.lurox-close-btn');

function openMenu() {
  luroxDrawer.classList.add('open');
  luroxOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  document.querySelectorAll('.lnav-desktop__item').forEach(function(item) {
    item.style.pointerEvents = 'none';
    item.style.zIndex = '0';
  });
}

function closeMenu() {
  luroxDrawer.classList.remove('open');
  luroxOverlay.classList.remove('open');
  document.body.style.overflow = '';
  document.querySelectorAll('.lnav-desktop__item').forEach(function(item) {
    item.style.pointerEvents = '';
    item.style.zIndex = '';
  });
  setTimeout(() => {
    document.querySelectorAll('.lurox-panel').forEach(p => p.classList.remove('active'));
    document.querySelector('.lurox-panel-main').classList.add('active');
    luroxDrawer.querySelector('.lurox-drawer-title').textContent = 'Menu';
  }, 300);
}

function openPanel(panelId, title) {
  document.querySelectorAll('.lurox-panel').forEach(p => p.classList.remove('active'));
  document.getElementById(panelId).classList.add('active');
  luroxDrawer.querySelector('.lurox-drawer-title').textContent = title;
}

function goBack() {
  const activePanel = document.querySelector('.lurox-panel.active');
  const parentId = activePanel.dataset.parent;
  const parentTitle = activePanel.dataset.parentTitle;
  document.querySelectorAll('.lurox-panel').forEach(p => p.classList.remove('active'));
  document.getElementById(parentId).classList.add('active');
  luroxDrawer.querySelector('.lurox-drawer-title').textContent = parentTitle;
}

luroxBtn.addEventListener('click', openMenu);
luroxClose.addEventListener('click', closeMenu);
luroxOverlay.addEventListener('click', closeMenu);

document.addEventListener('click', function(e) {
  if (e.target.closest('[data-panel]')) {
    const el = e.target.closest('[data-panel]');
    openPanel(el.dataset.panel, el.dataset.title);
  }
  if (e.target.closest('.lurox-back-btn')) {
    goBack();
  }
});